import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconBookmarkDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M4.042 4.158c0-.916.742-1.658 1.658-1.658h12.6c.916 0 1.658.742 1.658 1.658v16.68c0 1.462-1.752 2.209-2.806 1.197L12 17.087l-5.152 4.948c-1.053 1.012-2.806.265-2.806-1.196zm1.99.332v15.57l4.82-4.628a1.66 1.66 0 0 1 2.296 0l4.82 4.629V4.49z" clipRule="evenodd" /></svg></>;
}
IconBookmarkDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconBookmarkDefault;